/**
 * Lines the editor is pre-filled with: one list of {text, source, origin, ref_id, hedged} (the prefill contract's Line) becomes the
 * editor's strings plus a provenance map keyed by the exact text. Pure functions, shared by the local fallback and the server prefill.
 */
import { MAX_LIST_ITEMS } from "./editorRules";

export const LINE_SOURCE = Object.freeze({ SYMPTOM: "symptom", FACT: "fact", NOTE: "note", STEP: "step" });

/** The key two lines are the same under: case, whitespace and punctuation are ignored. */
export const normKey = (text) => String(text || "").toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();

const INFERRED_SUFFIX = /\s*\(\s*inferred from[^)]*\)\s*$/i;
export const cleanText = (text) => String(text || "").replace(INFERRED_SUFFIX, "").replace(/\s+/g, " ").trim();

export const metaOf = (line) => ({
  source: line.source || null,
  origin: line.origin || null,
  ref_id: line.ref_id || null,
  hedged: !!line.hedged,
});

/**
 * Cleans, dedupes and caps lines. Returns {texts, meta, keys, truncated}: `texts` in order (at most MAX_LIST_ITEMS), `meta` by
 * exact text, `keys` the normalised keys of the kept lines, `truncated` how many distinct lines were left out by the cap.
 */
export function packLines(lines, cap = MAX_LIST_ITEMS) {
  const seen = new Set();
  const kept = [];
  (Array.isArray(lines) ? lines : []).forEach((line) => {
    const text = cleanText(line && line.text);
    const key = normKey(text);
    if (!key || seen.has(key)) return;
    seen.add(key);
    kept.push({ text, line });
  });
  const shown = kept.slice(0, cap);
  const meta = {};
  shown.forEach(({ text, line }) => { meta[text] = metaOf(line); });
  return { texts: shown.map((k) => k.text), meta, keys: shown.map((k) => normKey(k.text)), truncated: kept.length - shown.length };
}
